

import axios from "axios";
import { decryptionData,datetimenow } from '@/components/utils/utils.js';
import io from 'socket.io-client';
export default {
  name: 'register',
  data () {
    return {
      socket: "",
      dialogInfo: false,
      // variabel tmp =====================================
      itemsKeywordRole: [],//form 1
      // variabel 1 input/insert ==========================
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
      keyword_role_id: "",
      topic: [],
      topic_interested: [],
      // person pin
      userIdNewPerson: "",
      userDisplayName: "",
      itemsPerson: [],
      btnLoading: false,
      isAddNewPerson: false,
      person_pinned: [],
      item_alias_person: [
        { alias : '', id_alias : '' }
      ],
      // organization pin
      userOrganizationDisplayName: "",
      userOrganizationAlias: "",
      itemsOrganization: [],
      btnLoadingOrganization: false,
      organization_pinned: [],

      item_aliasOrganization: [
        { alias : '', id_alias : '' }
      ],
      // end variabel 1 =================================
      dialogRegister: false,
      e1: 1,
      registerUserId: "",
      itemsInterested: "",
      valueIdInterested: [],
      messageError: "",
      search: "",

      dialogNewPerson: false,
      userIdRules: [
        v => !!v || 'Username Twitter is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      displayNameRules: [
        v => !!v || 'User Display Name is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      userType: 0,
      itemsUserType: [
        { value: 0, name: "Twitter" },
        { value: 1, name: "Youtube" }
      ],
      statusActive: 1,
      itemsActive: [
        { valueactive: 1, name_active: "Active" },
        { valueactive: 0, name_active: "Disable" }
      ],
      file: "",
      image_url: "",
      formValidPerson: false,
    

      dialogNewOrganization: false,
      organizationDisplayNameRules: [
        v => !!v || 'Organization display name is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      organizationAliasRules: [
        v => !!v || 'Organization Alias is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      fileOrganization: "",
      formValidOrganization: false,
      isAddNewOrganization: false,
      alertSuccess: "",
      alertFailed: "",
      alert_err_attention: "",

      searchOrganization: "",
      serverPRSIMAGE: process.env.VUE_APP_BASE_URL_API+"/upload/analyz_person/",
      serverORGIMAGE: process.env.VUE_APP_BASE_URL_API+"/upload/organization/",
      valueIdOrganization: [],
      showpassword: false,
      showconfirmpassword: false,
      errors: null,
      formValid: false,
      // user: {}
    }
  },
  computed: {
    searchItemsPerson: function () {
      return this.itemsPerson.filter((itemsPerson) => {
        return itemsPerson.USER_DISPLAY_NAME
          .toLowerCase()
          .match(this.search.toLowerCase());
      });
    },
    searchItemsOrganization: function () {
      return this.itemsOrganization.filter((itemsOrganization) => {
        return itemsOrganization.ORG_DISPLAY_NAME
          .toLowerCase()
          .match(this.searchOrganization.toLowerCase());
      });
    },
  },
  watch: {
    dialogNewPerson(val) {
      val || this.closeAddPerson();
    },
    dialogNewOrganization(val) {
      val || this.closeOrganization();
    },
  },
  mounted() {
    this.getKeywordRole();
    this.loadItemsPerson();
    this.loadItemsOrganization();
  },
  methods: {
    // Get data master fix =========================================================================================
    async getKeywordRole() {
      try {
        const data1 = await axios.get(
          "keyword_role_public",
        );
        const data = data1.data;
        this.itemsKeywordRole = data.role_keyword;
      } catch (e) {
        console.log(e);
      }
    },
    async loadItemsPerson() {
      try {
        const data1 = await axios.get(
          "/person_public",
        );
        const data = data1.data;
        this.itemsPerson = data.person;
        if (this.isAddNewPerson == false) {
          for (let i = 0; i < this.itemsPerson.length; i++) {
            this.itemsPerson[i].isSelect = false;
          }
        }
        this.isAddNewPerson = false;
      } catch (e) {
        console.log(e);
      }
    },
    async loadItemsOrganization() {
      try {
        const data1 = await axios.get(
          "/organization_public",
        );
        const data = data1.data;
        this.itemsOrganization = data.organization;
        if (this.isAddNewOrganization == false) {
          for (let i = 0; i < this.itemsOrganization.length; i++) {
            this.itemsOrganization[i].isSelect = false;
          }
        }
        this.isAddNewOrganization = false;
      } catch (e) {
        console.log(e);
      }
    },
    // end Get data master fix =========================================================================================
    // 4. temp pinned organization and add organization  ==========================================================================
    addAliasOrganization() {
      this.originalData = null;
      this.item_aliasOrganization.push({ alias: '', id_alias: '' });
    },
    removeAliasOrganization(item, index) {
      if (index > 0) {
        this.item_aliasOrganization.splice(index, 1);
      } else {
        alert('Baris Pertama tidak bisa dihapus');
      }
    },
    closeOrganization() {
      this.dialogNewOrganization = false;
    },
    async AddValidateFormPersonExample() {
      try {
        if (this.$refs.formPerson.validate()) {
              this.btnLoading = true;
              var arr_alias = [];
              var seq_id_alias = [];
              for (var alias of this.item_alias_person) {
                arr_alias.push(alias.alias);
                seq_id_alias.push(alias.id_alias);
              }
              let valueIdPersonId = {
                  "PERSON_ID": '',
                  "USER_ID_TWEET": this.userIdNewPerson,
                  "USER_DISPLAY_NAME": this.userDisplayName,
                  "USER_STATUS": this.statusActive,
                  "USER_TYPE": this.userType,
                  "USER_PROFILE_IMG_URL": this.image_url,
                  "USER_ALIAS": arr_alias,
                  "PRS_IMAGE": '',
              }
              let additemperson = {
                  "SEQ_ID": "",
                  "NER_PERSON": this.userIdNewPerson,
                  "PRS_IMAGE": '',
                  "PUBLIC_STATUS": 0,
                  "USER_DISPLAY_NAME": this.userIdNewPerson,
                  "USER_ID": this.userIdNewPerson,
                  "isSelect": true
              }
              // console.log(additemperson);
              this.isAddNewPerson = true;
              if (this.isAddNewPerson == true) {
                this.person_pinned.push(valueIdPersonId);
                this.itemsPerson.push(additemperson);
                this.alertSuccess = true;
                this.alert_err_attention = "Success Add Person "+this.userIdNewPerson;
                this.btnLoading = false;
                this.closeAddPerson();
              } else {
                this.alertFailed = true;
                this.alert_err_attention = "Failed Add Person";
                this.btnLoading = false;
              }
        }
      } catch (e) {
        this.errors = e.response.data.msg;
        this.alertFailed = true;
        this.alert_err_attention = "Failed Add Person";
        this.btnLoading = false;
      }
    },
    async AddValidateFormOrganization() {
      try {
        
        if (this.$refs.formOrganization.validate()) {
              this.btnLoadingOrganization = true;
              var arr_alias = [];
              var seq_id_alias = [];
              for (var alias of this.item_aliasOrganization) {
                arr_alias.push(alias.alias);
                seq_id_alias.push(alias.id_alias);
              }
              let valueIdOrganization = {
                  "SEQ_ID": "",
                  "ORG_DISPLAY_NAME": this.userOrganizationDisplayName,
                  "ORG_ALIAS": this.userOrganizationAlias,
                  "ARR_ALIAS": arr_alias,
                  "PUBLIC_STATUS": 0,
                  "ORG_IMAGE": "",
              }
              let additempOrganization = {
                  "SEQ_ID": "",
                  "ORG_DISPLAY_NAME": this.userOrganizationDisplayName,
                  "ORG_IMAGE": this.userIdNewPerson,
                  "PUBLIC_STATUS": this.userIdNewPerson,
                  "isSelect": true
              }
              this.isAddNewPerson = true;
              if (this.isAddNewPerson == true) {
                this.organization_pinned.push(valueIdOrganization);
                this.itemsOrganization.push(additempOrganization);
                this.alertSuccess = true;
                this.alert_err_attention = "Success Add Organization "+this.userOrganizationDisplayName;
                this.btnLoadingOrganization = false;
                this.closeOrganization();
              } else {
                this.alertFailed = true;
                this.alert_err_attention = "Failed Add Organization";
                this.btnLoadingOrganization = false;
              }
        }
      } catch (error) {
        this.alertFailed = true;
        this.alert_err_attention = "Failed Add Organization";
        this.btnLoadingOrganization = false;
        this.errors = error.response.data.msg;
      }
    },
    
    getIdOrganization(item, i) {
      console.log(item)
      // if (this.valueIdOrganization.includes(item.SEQ_ID)) {
      if (item.isSelect == true) {
        // const indexToRemove = this.valueIdOrganization.indexOf(item.SEQ_ID);
        // this.valueIdOrganization.splice(indexToRemove, 1);
        let index = this.organization_pinned.findIndex(organization => 
          organization.SEQ_ID === item.SEQ_ID || 
          organization.ORG_DISPLAY_NAME === item.ORG_DISPLAY_NAME
        );
        this.organization_pinned.splice(index, 1);
        this.$set(this.itemsOrganization, i, { ...item, isSelect: false });
      } else {
        // this.valueIdOrganization.push(item.SEQ_ID);
        this.$set(this.itemsOrganization, i, { ...item, isSelect: true });
        let valueIdOrganizationId = {
            "SEQ_ID": item.SEQ_ID,
            "ORG_DISPLAY_NAME": item.ORG_DISPLAY_NAME,
            "ORG_ALIAS": item.ORG_ALIAS,
            "PUBLIC_STATUS": item.PUBLIC_STATUS,
            "ORG_IMAGE": item.ORG_IMAGE,
        }
        
        this.organization_pinned.push(valueIdOrganizationId);
      }
    },
    async postFinishRegister() {
      // try {
        this.btnLoadingFinish = true;
        const data1 = await axios.post(
          "/register-new",
          {
            "username": this.username,
            "email": this.email,
            "password": this.password,
            "confPassword": this.confirmPassword,
            "keyword_role_id": this.keyword_role_id,
            "topic": this.topic_interested,
            "pinned_person": this.person_pinned,
            "pinned_organization": this.pinned_organization
          },
        );
        const data = data1.data;
        if (data.status == 200 || data.status == 201) {
          this.dialogRegister = false;
          this.dialogInfo = true;

          this.socket = io(process.env.VUE_APP_API_SOCKET); 
          this.socket.emit('message', { 
            type: 'notifikasi_register',//type ini untuk mengategorikan jenis data yg ada di socket.io
            text: 'Username <b>'+this.username+'</b> created register user Medan247',
            username: 'Username',
            url: '/registrasiuser',
            date: datetimenow(),
          });
          this.btnLoadingFinish = false;

        }else{
          this.alertFailed = true;
          this.alert_err_attention = data.msg;
          this.btnLoadingFinish = false;
        }
      // } catch (e) {
      //   console.log(e)
      //     this.alertFailed = true;
      //     this.alert_err_attention = "Register Failed";
      //     this.btnLoadingFinish = false;
      // }
    },
    // start fix function ==========================================================================================
    // 3. temp pinned person and add person
    // =====================temp checked pinned person ===================
    closeAddPerson() {
      this.dialogNewPerson = false;
    },
    addaliasperson() {
      this.originalData = null;
      this.item_alias_person.push({ alias: '', id_alias: '' });
    },
    deleteAliasPerson(item, index) {
      if (index > 0) {
        this.item_alias_person.splice(index, 1);
      } else {
        alert('Baris Pertama tidak bisa dihapus');
      }
    },
    async AddValidateFormPerson() {
      try {
        if (this.$refs.formPerson.validate()) {
              this.btnLoading = true;
              var arr_alias = [];
              var seq_id_alias = [];
              for (var alias of this.item_alias_person) {
                arr_alias.push(alias.alias);
                seq_id_alias.push(alias.id_alias);
              }
              let valueIdPersonId = {
                  "PERSON_ID": '',
                  "USER_ID_TWEET": this.userIdNewPerson,
                  "USER_DISPLAY_NAME": this.userDisplayName,
                  "USER_STATUS": this.statusActive,
                  "USER_TYPE": this.userType,
                  "USER_PROFILE_IMG_URL": this.image_url,
                  "USER_ALIAS": arr_alias,
                  "PRS_IMAGE": '',
              }
              this.isAddNewPerson = true;
              let additemperson = {
                  "SEQ_ID": "",
                  "NER_PERSON": this.userIdNewPerson,
                  "PRS_IMAGE": '',
                  "PUBLIC_STATUS": 0,
                  "USER_DISPLAY_NAME": this.userIdNewPerson,
                  "USER_ID": this.userIdNewPerson,
                  "isSelect": true
              }
              // console.log(additemperson);
              if (this.isAddNewPerson == true) {
                this.person_pinned.push(valueIdPersonId);
                this.itemsPerson.push(additemperson);
                this.alertSuccess = true;
                this.alert_err_attention = "Success Add Person "+this.userIdNewPerson;
                this.btnLoading = false;
                this.closeAddPerson();
              } else {
                this.alertFailed = true;
                this.alert_err_attention = "Failed Add Person";
                this.btnLoading = false;
              }
        }
      } catch (e) {
        this.errors = e.response.data.msg;
        this.alertFailed = true;
        this.alert_err_attention = "Failed Add Person";
        this.btnLoading = false;
      }
    },
    getIdPerson(item, i) {
      if (item.isSelect == true) {
        let index = this.person_pinned.findIndex(person => 
          person.PERSON_ID === item.PERSON_ID || 
          person.USER_DISPLAY_NAME === item.USER_DISPLAY_NAME
        );
        this.person_pinned.splice(index, 1);
        this.$set(this.itemsPerson, i, { ...item, isSelect: false });
      } else {
        this.$set(this.itemsPerson, i, { ...item, isSelect: true });
        let valueIdPersonId = {
            "PERSON_ID": item.SEQ_ID,
            "USER_ID_TWEET": item.USER_ID,
            "USER_DISPLAY_NAME": item.USER_DISPLAY_NAME,
            "USER_STATUS": item.PUBLIC_STATUS,
            "USER_TYPE": item.SEQ_ID,
            "PRS_IMAGE": item.PRS_IMAGE,
        }
        this.person_pinned.push(valueIdPersonId);
      }
    },
    async postPinnedPerson() {
      try {
        if (this.person_pinned && this.person_pinned.length > 0) {
          this.e1 = 3;
        } else {
          console.error("Array pinned person kosong");
          this.alert_err_attention = "Pinned Person Empty";

        }
      } catch (e) {
        console.log(e);
        this.alert_err_attention = "Error Please Youre Call Administrator";

      }
    },
    // ===================== temp pinned person ===================
    // 2. temp fungsi intersted =========================
    getIdInterested(item, i) {
      if (this.valueIdInterested.includes(item.TOPIC_ID)) {
        const indexToRemove = this.valueIdInterested.indexOf(item.TOPIC_ID);
        this.valueIdInterested.splice(indexToRemove, 1);
        this.$set(this.itemsInterested, i, { ...item, isSelect: false });
      } else {
        this.valueIdInterested.push(item.TOPIC_ID);
        this.$set(this.itemsInterested, i, { ...item, isSelect: true });
      }
      let originalArray = this.valueIdInterested;

      let valueIdInterested = originalArray.map(value => {
        return {
          "topic_id": value.toString()
        };
      });
      this.topic_interested = valueIdInterested;
    },
    async actionInterested() {
      try {
        if (this.topic_interested && this.topic_interested.length > 0) {
          this.e1 = 2;
        } else {
          console.error("Array topic_interested kosong");
        }
      } catch (e) {
        console.log(e);
      }
    },

    async getItemsInterested(data) {
      for (let i = 0; i < data.length; i++) {
        this.itemsInterested[i].isSelect = data[i].SELECTED;
        if (data[i].SELECTED == true) {
          this.valueIdInterested.push(data[i].TOPIC_ID);
          let originalArray = this.valueIdInterested;

          let valueIdInterested = originalArray.map(value => {
            return {
              "topic_id": value.toString()
            };
          });

          this.topic_interested = valueIdInterested;
        }
      }
    },

    // 1. validation register ==========================================================================
    validateForm() {
      if (this.$refs.form.validate()) {
        this.registerUser();
      }
    },
    registerUser() {
      axios.post(`/users-register-new`, {
        keyword_role_id: this.keyword_role_id
      })
      .then((response) => {
        if (response.data.status == 200 || response.data.status == 201) {
          this.dialogRegister = true;
          this.registerUserId = response.data.data.USER_ID;
          this.itemsInterested = response.data.data.TOPIC_INTERESTED;
          for (let i = 0; i < this.itemsInterested.length; i++) {
            this.itemsInterested[i].isSelect = false;
          }
          this.getItemsInterested(response.data.data.TOPIC_INTERESTED);
          // location.href = "/";
        }
      })
      .catch((e) => {
        this.errors = e.response.data.msg;
        setTimeout(() => {
          this.errors = "";
        }, 5000);
        // location.href = "/register";
      });
    },
    

    async cancelRegister() {
      try {
          this.alertSuccess = true;
          this.alert_err_attention = "Cancle Registrasi";
          this.dialogRegister = false;
          this.e1 = 1;
      } catch (e) {
        switch (e.response.status) {
        case 404:
          this.$refs.alert.error_login(404);
          break;
        case 403:
          this.$refs.alert.error_login(403);
          break;
        case 400:
          this.alertFailed = true;
          this.alert_err_attention = e.response.data.msg;
          break;
        default:
          console.log('some other error'); // end up here all the time
          break;
        }
        this.errors = e.response.data.msg;
      }
    },


  }
}